import request from '../request'

//获取所有省份
export function getProvince(params) {
  return request({ url: '/api/Colleges/getProvince',method: 'get',data: params})
}
//差院校
export function getCollegeList(params) {
  return request({ url: '/api/Colleges/getCollegeList',method: 'post',data: params})
}
//院校详情
export function getCollegeDetail(params) {
  return request({ url: '/api/Colleges/getCollegeDetail',method: 'post',data: params})
}
//院校详情
export function getCollegeDetails(params) {
  return request({ url: '/api/Colleges/getCollegeDetails',method: 'post',data: params})
}
//友情链接
export function FriendUrl_index(params) {
  return request({ url: '/api/FriendUrl/index',method: 'post',data: params})
}



// WEBPACK FOOTER //
// ./src/api/gw/config.js